export default {"src":"/_next/static/image/public/images/ic_video_on.ddb9eba4b85654a5aeda20b7030cb7c3.svg","height":56,"width":56};